module.exports = __webpack_public_path__ + "img/20200609_114630.5a352cb0.jpg";